import { render, staticRenderFns } from "./TheCalendarLastVersion.vue?vue&type=template&id=3fed0ce3&scoped=true&"
import script from "./TheCalendarLastVersion.vue?vue&type=script&lang=js&"
export * from "./TheCalendarLastVersion.vue?vue&type=script&lang=js&"
import style0 from "./TheCalendarLastVersion.vue?vue&type=style&index=0&id=3fed0ce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed0ce3",
  null
  
)

export default component.exports